import { Indicator } from '@toggle/helpers';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './SelectTabLine.styles';

interface SelectTabLineProps {
  onChange: (index: number, tabKey: string) => void;
  options: Indicator[];
  value: Indicator;
}

export const SelectTabLine: FC<SelectTabLineProps> = ({
  onChange,
  options,
  value,
}) => {
  const { t } = useTranslation('indicator');

  const createTabList = options.map(indicator => ({
    tabKey: indicator,
    /* i18next-extract-mark-context-next-line ["TLI", "RFI", "PI", "TI"] */
    tabLabel: t('indicator:title.text', {
      context: indicator,
    }),
  }));

  return (
    <S.StyledTabLines
      activeTab={value}
      onChange={onChange}
      tabs={createTabList}
    />
  );
};
